import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useLang from "Shared/hooks/useLanguage";
import useIsMobile from "Shared/hooks/useIsMobile";

interface IProps {
  testsLookup: any;
  setLeveyJenningsValues: React.Dispatch<React.SetStateAction<any>>;
  allTestsHeader: string;
  selectedTestsHeader: string;
}

const TestsSelection: React.FC<IProps> = ({
  testsLookup,
  setLeveyJenningsValues,
  allTestsHeader,
  selectedTestsHeader,
}) => {
  const isMobile = useIsMobile();

  const { t } = useLang();
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQuery2, setSearchQuery2] = useState("");
  const [allAnalytes, setAllAnalytes] = useState<any[]>([]);
  const [isCheckTestList, setisCheckTestList] = useState<any[]>([]);
  const [selectedAnalytes, setSelectedAnalytes] = useState<any[]>([]);
  const [selectedItemsToPop, setSelectedItemsToPop] = useState<any>([]);
  const [isCheckedSelectedList, setisCheckedSelectedList] = useState<any[]>([]);
  const [checkedList, setCheckedList] = useState({
    testList: [],
    selectedTestList: [],
  });

  const handleChangeTestList = (e: any, value: any, name: any, index: any) => {
    // Check if the item is already in isCheckTestList
    const isSelected = isCheckTestList.includes(value);

    if (isSelected) {
      // Remove the item from isCheckTestList
      setisCheckTestList(isCheckTestList.filter((item) => item !== value));
    } else {
      // Add the item to isCheckTestList
      setisCheckTestList([...isCheckTestList, value]);
    }

    // Then, update checkedList.testList
    setCheckedList((prevVal: any) => {
      if (isSelected) {
        // If it was selected, remove it from testList
        return {
          ...prevVal,
          testList: checkedList.testList.filter(
            (item: any) => item.value !== value
          ),
        };
      } else {
        // If it wasn't selected, add it to testList
        return {
          ...prevVal,
          testList: [...checkedList.testList, { value, label: name, index }],
        };
      }
    });
  };

  const handleChangeSelectedTestList = (value: any, name: any, index: any) => {
    // Check if the item is already in isCheckedSelectedList
    const isSelected = isCheckedSelectedList.includes(value);

    if (isSelected) {
      // Remove the item from isCheckedSelectedList
      setisCheckedSelectedList(
        isCheckedSelectedList.filter((item) => item !== value)
      );
      // Remove the item from selectedItemsToPop
      setSelectedItemsToPop(
        selectedItemsToPop.filter((item: any) => item.value !== value)
      );
      // Remove the item from checkedList.selectedTestList
      setCheckedList((prevVal) => {
        return {
          ...prevVal,
          selectedTestList: checkedList.selectedTestList.filter(
            (item: any) => item.value !== value
          ),
        };
      });
    } else {
      // Add the item to isCheckedSelectedList
      setisCheckedSelectedList([...isCheckedSelectedList, value]);
      // Add the item to selectedItemsToPop
      setSelectedItemsToPop([
        ...selectedItemsToPop,
        { value, label: name, index },
      ]);
      // Add the item to checkedList.selectedTestList
      setCheckedList((prevVal: any) => {
        return {
          ...prevVal,
          selectedTestList: [
            ...checkedList.selectedTestList,
            { value, label: name, index },
          ],
        };
      });
    }
  };

  const forwardPush = () => {
    if (checkedList.testList.length !== 0) {
      const originalArrCopy = Array.isArray(selectedAnalytes)
        ? [...selectedAnalytes]
        : [];
      const arrWithCheckedItems = Array.isArray(checkedList.testList)
        ? [...checkedList.testList]
        : [];

      const concatedArray = [
        ...(originalArrCopy || []),
        ...(arrWithCheckedItems || []),
      ];
      const currentArray = [...allAnalytes];

      // Remove the pushed items from the original Analytes array
      const updatedAnalytes = currentArray.filter((item: any) => {
        return !concatedArray.find((el) => el.value === item.value);
      });

      setAllAnalytes(updatedAnalytes);
      setSelectedAnalytes(concatedArray);
      setLeveyJenningsValues((preVal: any) => {
        return {
          ...preVal,
          testConfigIds: [
            ...new Set(
              (preVal?.testConfigIds || []).concat(
                concatedArray.map((item: any) => item.value)
              )
            ),
          ],
        };
      });
      setCheckedList((preVal: any) => {
        return {
          ...preVal,
          testList: [],
        };
      });
      setisCheckTestList([]);
    }
  };

  const backwardPush = () => {
    if (checkedList.selectedTestList.length !== 0) {
      const orignalArrCopy = [...allAnalytes];
      const arrWithCheckedItems: any = [...checkedList.selectedTestList];

      const concatedArray = [
        ...new Set(orignalArrCopy.concat(arrWithCheckedItems)),
      ];
      const currentArray = [...selectedAnalytes];

      const updatedAnalytes = currentArray.filter((item: any) => {
        return !concatedArray.find((el: any) => el.value === item.value);
      });
      setSelectedAnalytes(updatedAnalytes);
      setAllAnalytes(concatedArray);
      setCheckedList((preVal: any) => {
        return {
          ...preVal,
          selectedTestList: [],
        };
      });
      setLeveyJenningsValues((preVal: any) => {
        return {
          ...preVal,

          testConfigIds: updatedAnalytes.map((item: any) => item.value),
        };
      });
      setisCheckedSelectedList([]);
    }
  };

  const filteredAllAnalytes = allAnalytes.filter((test: any) =>
    test?.label?.toLowerCase().includes(searchQuery?.toLowerCase())
  );

  const filteredSelectedAnalytes = selectedAnalytes?.filter((test: any) =>
    test?.label?.toLowerCase().includes(searchQuery2?.toLowerCase())
  );

  const moveToSelectedAnalytes = () => {
    if (Array.isArray(allAnalytes)) {
      const allAnalytesCopy = [...allAnalytes];
      const selectedAnalytesCopy = Array.isArray(selectedAnalytes)
        ? [...selectedAnalytes]
        : [];
      const newAnalytes = [...selectedAnalytesCopy, ...allAnalytesCopy];
      setSelectedAnalytes(newAnalytes);
      setAllAnalytes([]);
    }
  };

  const moveToAllAnalytes = () => {
    if (Array.isArray(selectedAnalytes)) {
      const selectedTestCopy = [...selectedAnalytes];
      const allAnalytesCopy = Array.isArray(allAnalytes)
        ? [...allAnalytes]
        : [];
      const newAnalytes = [...allAnalytesCopy, ...selectedTestCopy];
      setAllAnalytes(newAnalytes);
      setSelectedAnalytes([]);
    }
  };

  useEffect(() => {
    forwardPush();
  }, [checkedList.testList]);

  useEffect(() => {
    backwardPush();
  }, [checkedList.selectedTestList]);

  useEffect(() => {
    setAllAnalytes(
      testsLookup
        .map((test: any) => ({
          value: test.value,
          label: test.label,
        }))
        .filter(
          (test: any) =>
            !selectedAnalytes?.some((item: any) => test.value === item.value)
        )
    );
    setLeveyJenningsValues((preVal: any) => {
      return {
        ...preVal,
        testConfigIds: selectedAnalytes?.map((item: any) => item.value),
      };
    });
  }, [selectedAnalytes, testsLookup]);

  useEffect(() => {
    setSelectedAnalytes([]);
  }, [testsLookup]);

  return (
    <>
      <div className="py-0">
        <div className="card shadow-sm rounded border border-warning">
          <div className="card-header px-4 d-flex justify-content-between align-items-center rounded bg-light-warning min-h-40px">
            <h6 className="text-warning mb-0">{t("Test Name")}</h6>
          </div>
          <div className="card-body py-md-4 py-3 px-4">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <div className="row">
                <div
                  className={
                    isMobile
                      ? "d-flex align-items-center flex-column justify-content-center"
                      : "d-flex align-items-center flex-wrap justify-content-around"
                  }
                >
                  {isMobile && (
                    <div className="d-flex flex-row justify-content-center gap-3 mb-3">
                      <span
                        className="align-content-center bg-warning d-flex justify-content-center p-3 rounded-1"
                        onClick={moveToSelectedAnalytes}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          id="AnalytesSelectAll"
                          style={{ fontSize: "20px", color: "white" }}
                          className="fa"
                        >
                          &#xf101;
                        </i>
                      </span>
                      <span
                        className="align-content-center bg-info d-flex justify-content-center p-3 rounded-1"
                        onClick={moveToAllAnalytes}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          id="AnalytesDeselectAll"
                          style={{ fontSize: "20px", color: "white" }}
                          className="fa"
                        >
                          &#xf100;
                        </i>
                      </span>
                    </div>
                  )}
                  <div
                    className={
                      isMobile ? "col-12 mb-3" : "col-lg-5 col-md-5 col-sm-12"
                    }
                  >
                    <input
                      id="AnalytesAllSearch"
                      type="text"
                      name=""
                      className="form-control bg-white mb-3 mb-lg-0 h-30px rounded-2 fs-8 w-100"
                      placeholder={t("Search...")}
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />

                    <div className="mt-2 border-1 border-light-dark border rounded overflow-hidden">
                      <div className="align-items-center bg-secondary d-flex h-40px justify-content-between px-4 rounded">
                        <span className="fw-bold">{t(allTestsHeader)}</span>
                      </div>

                      <ol
                        className={
                          isMobile
                            ? "list-group rounded-0 list-group-even-fill  scroll2"
                            : "list-group rounded-0 list-group-even-fill  h-325px scroll "
                        }
                      >
                        {filteredAllAnalytes?.map(
                          (items: any, index: number) => (
                            <li
                              id={`AnalytesAll_${items.value}`}
                              key={items.value}
                              className={
                                "list-group-item next-position px-2 py-1 border-0 cursor-pointer "
                              }
                              onClick={(e) =>
                                handleChangeTestList(
                                  e,
                                  items?.value,
                                  items?.label,
                                  index
                                )
                              }
                            >
                              <div className="d-flex">
                                <React.Fragment key={items?.value}>
                                  {items?.label}
                                </React.Fragment>
                              </div>
                            </li>
                          )
                        )}
                      </ol>
                    </div>
                  </div>
                  {!isMobile && (
                    <div className="align-items-center d-flex flex-md-column mt-2 justify-content-center gap-2 px-3">
                      <span
                        className="align-content-center bg-warning d-flex justify-content-center p-3 rounded-1"
                        onClick={moveToSelectedAnalytes}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          id="AnalytesSelectAll"
                          style={{ fontSize: "20px", color: "white" }}
                          className="fa"
                        >
                          &#xf101;
                        </i>
                      </span>
                      <span
                        className="align-content-center bg-info d-flex justify-content-center p-3 rounded-1"
                        onClick={moveToAllAnalytes}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          id="AnalytesDeselectAll"
                          style={{ fontSize: "20px", color: "white" }}
                          className="fa"
                        >
                          &#xf100;
                        </i>
                      </span>
                    </div>
                  )}
                  <div
                    className={
                      isMobile ? "col-12" : "col-lg-6 col-md-5 col-sm-12"
                    }
                  >
                    <input
                      id="AnalytesSelectedSearch"
                      type="text"
                      name=""
                      className="form-control bg-white mb-3 mb-lg-0 h-30px rounded-2 fs-8 w-100"
                      placeholder={t("Search...")}
                      value={searchQuery2}
                      onChange={(e) => setSearchQuery2(e.target.value)}
                    />
                    <div className="mt-2 border-1 border-light-dark border rounded overflow-hidden">
                      <div className="align-items-center bg-secondary d-flex h-40px justify-content-between px-4 rounded">
                        <span className="fw-bold">
                          {t(selectedTestsHeader)}
                        </span>
                      </div>

                      <ol
                        className={
                          isMobile
                            ? "list-group rounded-0 list-group-even-fill  scroll2"
                            : "list-group rounded-0 list-group-even-fill  h-325px scroll"
                        }
                      >
                        {filteredSelectedAnalytes?.map(
                          (item: any, index: number) => (
                            <li
                              id={`AnalytesSelectedFacility_${item.value}`}
                              key={item.value}
                              className={
                                "list-group-item next-position px-2 py-1 border-0 cursor-pointer "
                              }
                              onClick={() => {
                                if (!item?.isDisabled) {
                                  handleChangeSelectedTestList(
                                    item.value,
                                    item.label,
                                    index
                                  );
                                } else {
                                  toast.info(
                                    "Primary facility can not be removed"
                                  );
                                }
                              }}
                            >
                              <div className="d-flex">
                                <React.Fragment key={item.value}>
                                  {item.label}
                                </React.Fragment>
                              </div>
                            </li>
                          )
                        )}
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TestsSelection;
